import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { TabHeaderView } from "kea-react/dist/tabs/tabHeader";

type Entity = models.FiltroColonia;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ColoniaFiltroComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        
        const getField = this.getField;
        
        const Estado = getField(selectores.Estado);
        const IdEstado = this.props.value.IdEstado === undefined || this.props.value.IdEstado == null? 0 : this.props.value.IdEstado

        const Municipio = getField(selectores.MunicipioFiltroEstado( IdEstado ));
        const IdMunicipio = this.props.value.IdMunicipio === undefined || this.props.value.IdMunicipio == null? 0 : this.props.value.IdMunicipio

        const Ciudad = getField(selectores.CiudadFiltroMunicipio( IdMunicipio ));

        const Text = getField(kea.Text);

        //const EsProveedor = this.props.session.IdUsuarioZE != null && this.props.session.IdChoferZE == null
        //const EsChofer = this.props.session.IdUsuarioZE != null && this.props.session.IdChoferZE != null

        /*
        if (EsProveedor) {
            //this.props.value.IdProveedor = this.props.session.IdUsuarioZE
        }
        if (EsChofer) {
            //this.props.value.IdProveedor = this.props.session.IdUsuarioZE
            //this.props.value.IdChofer = this.props.session.IdChoferZE
        }
        
        const validarChoferId = this.props.value.IdChofer === undefined || this.props.value.IdChofer == null? 0 : this.props.value.IdChofer
        const validarProveedorId = this.props.value.IdProveedor === undefined || this.props.value.IdProveedor == null? 0 : this.props.value.IdProveedor

        const Vehiculo2 = getField(selectores.VehiculoByChoferId( validarChoferId ));
        const Chofer = getField(selectores.ChoferZEByUserZE(validarProveedorId));
        */

        const { value } = this.props;
        return (
            <div>
                {kea.autogrid(3, [
                    <Estado field="IdEstado" label="Estado"  />,
                    <Municipio field="IdMunicipio" label="Municipio"  />,
                    <Ciudad field="IdCiudad" label="Ciudad"  />,
                    <Text field="CodigoPostal" label="Codigo postal"  />,
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/DireccionColonia/list/filtro.tsx